// extracted by mini-css-extract-plugin
module.exports = {"root":"logo_root__JKE4h","isGarneczki":"logo_isGarneczki__IB_jP"};